export class AccessoryAmountMovement {
  constructor(public localType?: number,
              public localId?: number,
              public accessoryStatusId?: number,
              public quantity?: number,
              public accessoryId?: number,
              public accessoryName?: string,
              public local?,
              public accessoryStatus?,
              public attendingId?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/accessory-amount-movement.ts